"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var baseTheme_exports = {};
__export(baseTheme_exports, {
  BaseTheme: () => BaseTheme,
  baseTheme: () => baseTheme
});
module.exports = __toCommonJS(baseTheme_exports);
const screens = {
  xs: "320px",
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  xxl: "1600px"
};
const colors = {
  inherit: "inherit",
  current: "currentColor",
  transparent: "transparent",
  // Primary
  primary130: "var(--primary130, #512000)",
  primary120: "var(--primary120, #792F00)",
  primary110: "var(--primary110, #A23F00)",
  primary100: "var(--primary100, #CA4F00)",
  primary30: "var(--primary30, #F4DCCC)",
  primary20: "var(--primary20, #FAEDE6)",
  primary10: "var(--primary10, #FAF5F2)",
  // Secondary
  secondary130: "var(--secondary130, #776931)",
  secondary120: "var(--secondary120, #9B8F5F)",
  secondary110: "var(--secondary110, #BFB48C)",
  secondary100: "var(--secondary100, #E3DABA)",
  secondary30: "var(--secondary30, #EAE4CC)",
  secondary20: "var(--secondary20, #F1EDDD)",
  secondary10: "var(--secondary10, #F9F8F1)",
  // Neutral
  black: "var(--black, #111111)",
  neutral120: "var(--neutral120, #525252)",
  neutral110: "var(--neutral110, #767676)",
  neutral100: "var(--neutral100, #C8C8C8)",
  neutral40: "var(--neutral40, #BFC6D6)",
  neutral30: "var(--neutral30, #DFDFDF)",
  neutral20: "var(--neutral20, #F0F0F0)",
  neutral10: "var(--neutral10, #F9F9F9)",
  white: "var(--white, #FFFFFF)",
  // Success
  success130: "var(--success130, #003717)",
  success120: "var(--success120, #015222)",
  success110: "var(--success110, #016E2E)",
  success100: "var(--success100, #018939)",
  success30: "var(--success30, #80C49C)",
  success20: "var(--success20, #B3DCC4)",
  success10: "var(--success10, #E6F3EB)",
  // Warning
  warning130: "var(--warning130, #432200)",
  warning120: "var(--warning120, #864300)",
  warning110: "var(--warning110, #B35A00)",
  warning100: "var(--warning100, #E07000)",
  warning30: "var(--warning30, #F0B880)",
  warning20: "var(--warning20, #F6D4B3)",
  warning10: "var(--warning10, #FCF1E6)",
  // Error
  error130: "var(--error130, #4E1111)",
  error120: "var(--error120, #761919)",
  error110: "var(--error110, #9D2222)",
  error100: "var(--error100, #C42A2A)",
  error30: "var(--error30, #E29595)",
  error20: "var(--error20, #EDBFBF)",
  error10: "var(--error10, #F9EAEA)",
  // Informative
  info130: "var(--info130, #0F3540)",
  info120: "var(--info120, #185466)",
  info110: "var(--info110, #2688A6)",
  info100: "var(--info100, #2EC7E9)",
  info30: "var(--info30, #C3ECF8)",
  info20: "var(--info20, #D7F2FB)",
  info10: "var(--info10, #EBF9FD)",
  // Overlay
  overlayBlack50: "var(--black50, #00000050)",
  overlayBrand85: "var(--brand85, #09212C85)",
  dialogOverlay: "var(--dialog-overlay, #171B4985)",
  // Product colors
  "a&l": "var(--product-al)",
  bb: "var(--product-bb)",
  em: "var(--product-em)",
  em2: "var(--product-em2)",
  geodes: "var(--product-geodes)",
  phd: "var(--product-phd)",
  ww: "var(--product-ww)",
  // Shadows
  shadowNull: "var(--shadow-null, #3031330)",
  shadowLow: "var(--shadow-low, #30313312)",
  shadowMid: "var(--shadow-mid, #30313312)",
  shadowHigh: "var(--shadow-high, #30313312)",
  shadowOutline: "var(--shadow-outline, #30313312)",
  // Grading
  gradingLowest: "var(--grading-lowest, #FF19F6)",
  gradingLowestDarker: "var(--grading-lowest-darker, #FF19F6)",
  gradingLow: "var(--grading-low, #FF19F6)",
  gradingLowDarker: "var(--grading-low-darker, #FF19F6)",
  gradingMid: "var(--grading-mid, #FF19F6)",
  gradingMidDarker: "var(--grading-mid-darker, #FF19F6)",
  gradingHigh: "var(--grading-high, #FF19F6)",
  gradingHighDarker: "var(--grading-high-darker, #FF19F6)",
  gradingHighest: "var(--grading-highest, #FF19F6)",
  gradingHighestDarker: "var(--grading-highest-darker, #FF19F6)",
  //Backgrounds
  page: "var(--color-bg-page)",
  raised: "var(--color-bg-raised)",
  inset: "var(--color-bg-inset)"
};
const spacing = {
  null: "var(--spacing-null, 0rem)",
  // 0px
  "3xs": "var(--spacing-3xs, 0.125rem)",
  // 2px
  "2xs": "var(--spacing-2xs, 0.25rem)",
  // 4px
  xs: "var(--spacing-xs, 0.5rem)",
  // 8px
  s: "var(--spacing-s, 0.75rem)",
  // 12px
  m: "var(--spacing-m, 1rem)",
  // 16px
  l: "var(--spacing-l, 1.5rem)",
  // 24px
  xl: "var(--spacing-xl, 2rem)",
  // 32px
  "2xl": "var(--spacing-2xl, 2.5rem)",
  // 40px
  "3xl": "var(--spacing-3xl, 3rem)",
  // 48px
  "4xl": "var(--spacing-4xl, 3.5rem)",
  // 56px
  "5xl": "var(--spacing-5xl, 4rem)",
  // 64px
  "6xl": "var(--spacing-6xl, 5rem)"
  // 80px
};
const borderRadius = {
  none: "var(--border-radius-none, 0rem)",
  xs: "var(--border-radius-xs, 0.125rem)",
  // 2px
  s: "var(--border-radius-s, 0.25rem)",
  // 4px
  m: "var(--border-radius-m, 0.5rem)",
  // 8px
  l: "var(--border-radius-l, 0.625rem)",
  // 10px
  xl: "var(--border-radius-xl, 0.75rem)",
  // 12px
  "2xl": "var(--border-radius-2xl, 1rem)",
  // 16px
  "3xl": "var(--border-radius-3xl, 1.25rem)",
  // 20px
  full: "var(--border-radius-full, 999rem)"
  // 9999px
};
const borderWidth = {
  0: "var(--border-width-0)",
  1: "var(--border-width-1)",
  // 1px
  2: "var(--border-width-2)",
  // 2px
  4: "var(--border-width-4)",
  // 4px
  6: "var(--border-width-6)",
  // 6px
  8: "var(--border-width-8)",
  // 8px
  12: "var(--border-width-12)"
  // 12px
};
const fontFamily = {
  primary: "var(--font-family-circular)",
  studentExp: "var(--font-family-circular)",
  teacherExp: "var(--font-family-circular)",
  fontSans: "var(--font-family-circular)"
};
const fontSize = {
  rootFontSize: "var(--font-size-root)",
  extraSmall: "var(--font-size-xs)",
  // 12px
  small: "var(--font-size-sm)",
  // 14px
  medium: "var(--font-size-base)",
  // 16px
  large: "var(--font-size-lg)",
  // 18px
  extraLarge: "var(--font-size-2xl)",
  // 22px
  extraExtraLarge: "var(--font-size-5xl)",
  // 26px
  huge: "var(--font-size-10xl)",
  // 36px
  extraHuge: "var(--font-size-13xl)",
  // 52px
  extraExtraHuge: "var(--font-size-14xl)"
  // 56px
};
const fontWeight = {
  light: "var(--font-weight-light)",
  regular: "var(--font-weight-regular)",
  book: "var(--font-weight-book)",
  medium: "var(--font-weight-medium)",
  semiBold: "var(--font-weight-semiBold)",
  bold: "var(--font-weight-bold)",
  black: "var(--font-weight-black)"
};
const typography = {
  headings: {
    h1: "var(--font-size-base)",
    // 16px
    h2: "var(--font-size-2xl)",
    // 22px
    h3: "var(--font-size-lg)",
    // 18px
    h4: "var(--font-size-sm)"
    // 14px
  },
  titles: {
    huge: "var(--font-size-14xl)",
    // '3.5rem', // 56px
    page: "var(--font-size-12xl)",
    // '2.75rem', // 44px
    main: "var(--font-size-10xl)",
    // '2.25rem', // 36px
    subtitle: "var(--font-size-5xl)",
    // '1.625rem', // 26px
    minor: "var(--font-size-xs)"
    // '0.75rem', // 12px
  },
  textStyles: {
    textBase: "var(--font-size-base)",
    // '1rem', // 16px
    textSmall: "var(--font-size-sm)",
    // '0.875rem', // 14px
    textLink: "var(--font-size-sm)"
    // '0.875rem', // 14px
  }
};
const boxShadow = {
  null: "var(--box-shadow-null)",
  low: "var(--box-shadow-low)",
  medium: "var(--box-shadow-medium)",
  high: "var(--box-shadow-high)",
  outline: "var(--box-shadow-outline)"
};
const container = {
  screens: {
    sm: "var(--default-container-screen-styles)",
    md: "var(--default-container-screen-styles)",
    lg: "var(--default-container-screen-styles)",
    xl: "var(--default-container-screen-styles)",
    xxl: "var(--default-container-screen-styles)",
    xxxl: "var(--xxl-container-screen-styles)"
  }
};
const zIndex = {
  base: "0",
  100: "var(--zindex-100)",
  200: "var(--zindex-200)",
  300: "var(--zindex-300)",
  400: "var(--zindex-400)",
  500: "var(--zindex-500)",
  600: "var(--zindex-600)",
  700: "var(--zindex-700)",
  800: "var(--zindex-800)"
};
const ringWidth = {
  focusRing: "var(--border-width-1)"
};
const baseTheme = {
  theme: {
    // Overwrites Tailwind Classes.
    screens,
    fontFamily,
    colors,
    container,
    borderRadius,
    extend: {
      // Extends Tailwind Classes (preserve the default values for a theme option but also add new values).
      spacing,
      borderWidth,
      fontSize,
      fontWeight,
      typography,
      boxShadow,
      zIndex,
      ringWidth
    }
  }
};
const BaseTheme = typeof baseTheme;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BaseTheme,
  baseTheme
});
//# sourceMappingURL=baseTheme.js.map